module.exports = __webpack_public_path__ + "static/media/goldItem.2776c66d.svg";